// Constants
export const aportes_registro = () => {
    return {
        aportes_registro: {
            id: {
                namepath: ['aportes_registrar', 'servicios_aportes', 'archivo_retiros'],
                type: "number",
                label: "id",
                placeholder: "",
                description: "",
                validate: "",
                datatype: {
                    type: "input",
                    disabled: true,
                    predeterminate: null,
                }
            },
            id_datos_afiliado: {
                type: "string",
                label: "",
                placeholder: "",
                namepath: ['aportes_registrar', 'servicios_aportes', 'archivo_retiros'],
                description: "",
                validate: "required",
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: null,
                    list: "datos_afiliado",
                    label: 'name'
                }
            },
            id_info_afiliacion: {
                type: "string",
                label: "",
                placeholder: "",
                namepath: ['aportes_registrar', 'servicios_aportes', 'archivo_retiros'],
                description: "",
                validate: "required",
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: null,
                    list: "",
                    label: 'name'
                }
            },
            id_info_aportes: {
                type: "string",
                label: "",
                placeholder: "",
                namepath: ['aportes_registrar', 'servicios_aportes', 'archivo_retiros'],
                description: "",
                validate: "required",
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: null,
                    list: "",
                    label: 'name'
                }
            },
            id_datos_asesor: {
                type: "string",
                label: "Asesor",
                placeholder: "",
                namepath: ['aportes_registrar', 'servicios_aportes', 'archivo_retiros'],
                description: "",
                validate: "required",
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: null,
                    list: "datos_asesor",
                    label: 'name'
                }
            },
            id_datos_razon: {
                type: "string",
                label: "Razón Social",
                placeholder: "",
                namepath: ['aportes_registrar', 'servicios_aportes', 'archivo_retiros'],
                description: "",
                validate: "required",
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: null,
                    list: "datos_razon",
                    label: 'name'
                }
            },
            id_list_novedad: {
                type: "string",
                label: "Razón Social",
                placeholder: "",
                namepath: ['aportes_registrar', 'servicios_aportes', 'archivo_retiros'],
                description: "",
                validate: "required",
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: null,
                    list: "list_novedad",
                    label: 'name'
                }
            },
            fecha: {
                type: "number",
                label: "Fecha",
                placeholder: "",
                namepath: ['aportes_registrar', 'servicios_aportes', 'archivo_retiros'],
                description: "",
                validate: "",
                datatype: {
                    type: "date",
                    disabled: false,
                    predeterminate: null,
                }
            },
            servicios: {
                type: "text",
                label: "",
                placeholder: "",
                namepath: ['aportes_registrar', 'servicios_aportes', 'archivo_retiros'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null
                }
            },
            servicio: {
                type: "number",
                label: "Servicios",
                placeholder: "",
                namepath: ['aportes_registrar', 'servicios_aportes', 'archivo_retiros'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: 0,
                }
            },
            ano_periodo: {
                type: "text",
                label: "Año aporte",
                placeholder: "",
                namepath: ['aportes_registrar', 'servicios_aportes', 'archivo_retiros'],
                description: "",
                validate: "required",
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: 2020,
                    list: "list_ano",
                    label: 'name'
                }
            },
            mes_periodo: {
                type: "text",
                label: "Mes aporte",
                placeholder: "",
                namepath: ['aportes_registrar', 'servicios_aportes', 'archivo_retiros'],
                description: "",
                validate: "required",
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: 1,
                    list: "list_mes",
                    label: 'name'
                }
            },
            valor: {
                type: "number",
                label: "Valor",
                placeholder: "",
                namepath: ['aportes_registrar', 'servicios_aportes', 'archivo_retiros'],
                description: "",
                validate: "required",
                datatype: {
                    type: "price",
                    disabled: false,
                    predeterminate: 0,
                    prepend: '$',
                    append: '',
                }
            },
            reporte: {
                type: "number",
                label: "Reporte",
                placeholder: "",
                namepath: ['aportes_registrar', 'servicios_aportes', 'archivo_retiros'],
                description: "",
                validate: "required",
                datatype: {
                    type: "price",
                    disabled: false,
                    predeterminate: 0,
                    prepend: '$',
                    append: '',
                }
            },
            comision: {
                type: "number",
                label: "Comision",
                placeholder: "",
                namepath: ['aportes_registrar', 'servicios_aportes', 'archivo_retiros'],
                description: "",
                validate: "required",
                datatype: {
                    type: "price",
                    disabled: false,
                    predeterminate: 0,
                    prepend: '$',
                    append: '',
                }
            },
            nota_delete: {
                type: "text",
                label: "Nota",
                placeholder: "",
                namepath: [''],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null
                }
            },
        }
    }
}